import { styled } from 'styled-components';

const PreviewIconContainer = styled.div.withConfig({
  displayName: "PreviewIconContainer",
  componentId: "sc-8690a4a5-0"
})([
  `position:absolute;top:0.25rem;left:0.25rem;height:3rem;width:3rem;display:flex;align-items:center;justify-content:center;z-index:1;svg{height:1.875rem !important;width:1.875rem !important;margin-left:0.5rem;}`
]);

export { PreviewIconContainer };
//# sourceMappingURL=PreviewIconContainer.js.map
